// 인플루언서 관리 메인 페이지 

import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import InfluencerPendingListRead from '../../components/admin/influencer/InfluencerPendingListRead';
import InfluencerContractPendingListRead from '../../components/admin/influencer/InfluencerContractPendingListRead';
import InfluencerSNSUpdateList from '../../components/admin/influencer/InfluencerSNSUpdateList';
import InfluencerSNSAddList from '../../components/admin/influencer/InfluencerSNSAddList';
import InfluencerInquiryList from '../../components/admin/influencer/InfluencerInquiryList';
import InfluencerExchangeSummary from '../../components/admin/influencer/InfluencerExchangeSummary';
import InfluencerInfoSummary from '../../components/admin/influencer/InfluencerInfoSummary';
import '../../styles/pages/AdminPages.css';

function InfluencerPage() {
  const navigate = useNavigate();

  return (
    <AdminLayout title="인플루언서 관리">

      <div className="admin-page__dashboard">
        {/* 가입 승인 박스 */}
        <div className="admin-page__section">
          <InfluencerPendingListRead interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/register-check')}>
              관리
            </button>
          </div>
        </div>

        {/* 프리랜서 계약 관리 박스 */}
        <div className="admin-page__section">
          <InfluencerContractPendingListRead interactive={false} showSearch={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/free-contract')}>
              관리
            </button>
          </div>
        </div>

        {/* SNS 갱신 요청 박스 */}
        <div className="admin-page__section">
          <InfluencerSNSUpdateList interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/sns-update')}>
              관리
            </button>
          </div>
        </div>

        {/* SNS 추가 요청 박스 */}
        <div className="admin-page__section">
          <InfluencerSNSAddList interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/sns-add')}>
              관리
            </button>
          </div>
        </div>

        {/* 인플루언서 문의 */}
        <div className="admin-page__section">
          <InfluencerInquiryList interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/inquiry-check')}>
              관리
            </button>
          </div>
        </div>

        {/* 인플루언서 환전 요청 박스 */}
        <div className="admin-page__section">
          <InfluencerExchangeSummary interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/exchange')}>
              관리
            </button>
          </div>
        </div>

        {/* 인플루언서 정보관리 박스 */}
        <div className="admin-page__section">
          <InfluencerInfoSummary />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/influencer/info-management')}>
              관리
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default InfluencerPage;
